var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningDiffPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H17C19.2091 0 21 1.79086 21 4V16C21 18.2091 19.2091 20 17 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#FFF2CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.36 11.376H10.912V13.956H10.042V11.376H7.606V10.566H10.042V8.004H10.912V10.566H13.36V11.376Z",
    fill: "#F2B90D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningDiffPositive);
export default __webpack_public_path__ + "static/media/warningDiffPositive.5401a5496c494406fff0b79ad8614403.svg";
export { ForwardRef as ReactComponent };